var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard",staticStyle:{"max-width":"100%","padding-top":"4em"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }